import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import OurProcess from "../Components/OurProcess/OurProcess";
import ClubFitting from "../Components/ClubFitting/ClubFitting";
import FittingRates from "../Components/FittingRates/FittingRates";
import Footer from "../Components/Footer/Footer";
import { BsCheck2 } from "react-icons/bs";
import RemoateFitting from "../Components/RemoateFitting/RemoateFitting";
import ContactUs from "../Components/ContactUs/ContactUs";
import { isBrowser, isMobile } from 'react-device-detect';
import { Helmet } from "react-helmet";
import FindFitting from "../Components/FindFitting/FindFitting";
import { apiCall, getCurrentUser } from "../Api/auth";
import { IoClose } from "react-icons/io5";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { addStaff } from "../Api/staff";
import { getcountriesforfitter, getstates, getcities, } from '../Api/iron'


function Clubfitting() {

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const [width, setWidth] = useState(window.innerWidth);

    const [isuserlogin, setIsUserLogin] = useState(false);

    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setIsUserLogin(true);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
        getallcountry();
    }, []);



    const [loginusercallback, setloginusercallback] = useState(null);


    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    })

    const [showfitter, setShowfitter] = useState(false);
    const handleClosefitter = () => setShowfitter(false);
    const handleShowfitter = () => setShowfitter(true);

    const [validated, setValidated] = useState(false);
    const [apiCall, setApicall] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [shippingAddress, setShippingAddress] = useState("");

    //new code
    const [country_id, setCountry_id] = useState('');
    const [state_id, setState_id] = useState('');
    const [city_id, setCity_id] = useState('');
    const [zipcode, setzipcode] = useState('');
    const [bio, setbio] = useState('');


    const [countrylist, setCountrylist] = useState([]);
    const [statelist, setStatelist] = useState([]);
    const [citylist, setCitylist] = useState([]);

    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);

    const [serverSideError, setServerSideError] = useState(null);

    const handleSubmit = (event) => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();

            const data = {
                firstname: firstName,
                lastname: lastName,
                business_name: businessName,
                phone: phone,
                email: email,
                website_url: website,
                shipping_address: shippingAddress,
                role_id: 9,
                password: "12345678",
                confirmPassword: "12345678",
                country: country_id,
                state: state_id,
                city: city_id,
                zip: zipcode,
                bio: bio,
            };

            addStaff(data).then((res) => {
                console.log(res);
                if (!res.data.status) {
                    console.log("res.data.error", res.data.error);
                    setServerSideError(res.data.error);
                } else {
                    handleClosefitter();
                    setFirstName("");
                    setLastName("");
                    setBusinessName("");
                    setPhone("");
                    setEmail("");
                    setWebsite("");
                    setShippingAddress("");
                    setServerSideError(null);
                    setValidated(false);
                    // window.location.href = "/user-dashboard";

                    setCountry_id('');
                    setState_id('');
                    setCity_id('');
                    setzipcode('');
                    setbio('');
                    setStatelist([]);
                    setCitylist([]);
                }
            }).catch((err) => {
                // alert(err);
                console.log(err);
            }).finally(() => {
                setApicall(false);
                // setValidated(false);
            });
        }


        setValidated(true);
    }

    const [showpopup, setShowPopup] = useState(0);

    const showfunction = () => {
        setShowPopup(showpopup + 1);
    }

    const getallcountry = () => {
        getcountriesforfitter()
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCountrylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallstatefunc = (country_id) => {
        setStateLoading(true)
        const data = {
            country_id: country_id,
        };
        getstates(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setStateLoading(false)
                    const data = response.data.data;
                    setStatelist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallcityfunc = (state_id) => {
        setCityLoading(true);
        const data = {
            state_id: state_id,
        };
        getcities(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setCityLoading(false);
                    const data = response.data.data;
                    setCitylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const currentUserData = getCurrentUser();
        if (currentUserData && currentUserData.user) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
            console.error("Current user data is null or undefined");
        }
    }, []);

    const handleShowFitterlogin = () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user) {
            setIsLoggedIn(true);
        }
        const role_id = user?.role_id;


        if (!role_id) {

            // Redirect based on role
            switch (role_id) {
                case 4:
                    window.location.href = "/user-dashboard";
                    break;
                case 1:
                    window.location.href = "/fitter-dashboard";
                    break;
                case 8:
                    window.location.href = "/fitter-builder-dashboard";
                    break;
                case 7:
                    window.location.href = "/builder-dashboard";
                    break;
                case 10:
                    window.location.href = "/fitter-dashboard";
                    break;
                default:
                    window.location.href = "/dashboard";
            }
        }
    };

    return (
        <>

            <Helmet>
                <title>Club Fitting</title>
                <meta name="description" content="If we cant find a shaft + club head combo that out performs your current set of clubs, we will refund you and still provide your club fitting for free." />
                <link rel="canonical" href="https://foreward.golf/club-fitting" />
                {/* <!-- Facebook Meta Tags --> */}
                <meta property="og:url" content="https://foreward.golf/club-fitting" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Club Fitting" />
                <meta property="og:description" content="If we cant find a shaft + club head combo that out performs your current set of clubs, we will refund you and still provide your club fitting for free." />
                <meta property="og:image" content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`} />

                {/* <!-- Twitter Meta Tags --> */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content="foreward.golf" />
                <meta property="twitter:url" content="https://foreward.golf/club-fitting" />
                <meta name="twitter:title" content="Club Fitting" />
                <meta name="twitter:description" content="If we cant find a shaft + club head combo that out performs your current set of clubs, we will refund you and still provide your club fitting for free." />
                <meta name="twitter:image" content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`} />


            </Helmet>


            <Modal centered show={showfitter} onHide={handleClosefitter} className="card-radius popup-modal-dark add_club_modal build_sheet_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Fitter Application</h3>
                            <button type="button" className="btn-close" onClick={handleClosefitter} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-long-form'>
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <div className="row gap-4">
                                <div className='row pe-0' controlid="validationCustom011">
                                    <div className='col-md-6'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a first name.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a last name.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom012">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={businessName} onChange={(e) => setBusinessName
                                                (e.target.value)} placeholder="Business Name" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a business name
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom013">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a phone number.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom014">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="email" class="form-control dashboard-input-box-3" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid email address.
                                            </Form.Control.Feedback>
                                            {serverSideError && Array.isArray(serverSideError) && serverSideError.map((error, index) => (
                                                error.field === 'email' ? (
                                                    <div className="text-danger" key={index}>{error.message}</div>
                                                ) : null
                                            ))}

                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom015">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://example.com" />
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <textarea type="text" class="form-control dashboard-input-box-3" value={shippingAddress} onChange={(e) => setShippingAddress(e.target.value)} placeholder="Shipping Address" style={{ height: "100px" }} required />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a shipping address.
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>

                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-6'>
                                        <div className='form-group-input'>
                                            <select name="country" value={country_id} onChange={(e) => {
                                                setCountry_id(e.target.value);
                                                setState_id(0);
                                                setCity_id(0);
                                                getallstatefunc(
                                                    e.target.value
                                                );
                                            }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                required
                                            >
                                                <option value={0}>
                                                    Country
                                                </option>
                                                {countrylist &&
                                                    countrylist.map(
                                                        (item) => (
                                                            <option
                                                                value={item._id}
                                                                key={item._id}
                                                            >
                                                                {item.name}
                                                            </option>
                                                        )
                                                    )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <select name="state" value={state_id} onChange={(e) => {
                                                setState_id(e.target.value)
                                                getallcityfunc(
                                                    e.target.value
                                                );
                                            }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                required
                                            >
                                                {stateLoading ? (
                                                    <option disabled>Loading...</option>
                                                ) : (
                                                    <>
                                                        <option value={0}>State</option>
                                                        {statelist &&
                                                            statelist.map((item) => (
                                                                <option value={item._id} key={item._id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-6'>
                                        <div className='form-group-input'>
                                            <select name="city" value={city_id} onChange={(e) => { setCity_id(e.target.value); }}
                                                class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example" required>
                                                {cityLoading ? (
                                                    <option disabled>Loading...</option>
                                                ) : (
                                                    <>
                                                        <option value={0}>City/Town</option>
                                                        {citylist &&
                                                            citylist.map((item) => (
                                                                <option value={item._id} key={item._id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 md-5 pe-0'>
                                        <div className='form-group-input'>
                                            <input type="text" class="form-control dashboard-input-box-3" value={zipcode} onChange={(e) => setzipcode(e.target.value)} placeholder="Zip code" required />
                                        </div>
                                    </div>
                                </div>
                                <div className='row pe-0' controlid="validationCustom016">
                                    <div className='col-md-12 pe-0'>
                                        <div className='form-group-input'>
                                            <textarea type="text" class="form-control dashboard-input-box-3" value={bio} onChange={(e) => setbio(e.target.value)} placeholder="Bio..." style={{ height: "100px" }} />
                                        </div>
                                    </div>
                                </div>

                                <div className='row pe-0'>
                                    <div className='full-width-btn pe-0'>
                                        <>
                                            {
                                                apiCall ? (
                                                    <button className="btn btn_default text-dark btn_disabled" type="submit" disabled>
                                                        <span>...Submit Fitter Application</span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn_default text-dark btn_disabled" type="submit">
                                                        <span>Submit Fitter Application</span>
                                                    </button>
                                                )
                                            }

                                            {/* <button className="btn btn_default text-dark btn_disabled" type="submit">Submit Fitter Application</button> */}
                                        </>
                                    </div>
                                </div>
                            </div>
                        </Form>

                    </div>
                </Modal.Body>
            </Modal>

            <Header loginusercallback={loginusercallback} showremotefittingpopup={(poparg) => setShowPopup(poparg)} />
            <section id="hero" className="hero img_bg page-section">

                {width > 480 ? (
                    <div className="iframe-hero">
                        <iframe loading="eager" src="https://player.vimeo.com/video/903908400?autoplay=1&controls=0&loop=1&muted=1" frameBorder={0} allowFullScreen webkit-playsinline playsinline />
                    </div>
                ) : (
                    <div className="iframe-hero">
                        <iframe loading="eager" src="https://player.vimeo.com/video/903909691?autoplay=1&controls=0&loop=1&muted=1" frameBorder={0} allowFullScreen webkit-playsinline playsinline />
                    </div>
                )}

                <div className="container-xl">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="hero_content">
                                <h1 className="hide_mobile">
                                    With our process your<br /> fitting is guaranteed
                                </h1>
                                <h2 >
                                    <span className="hide_mobile">
                                        If we can't find a shaft + club head combo that outperforms your current <br />
                                        set of clubs, we will refund you and still provide your club fitting for free.
                                    </span>
                                </h2>
                                <h1 className="show_mobile">
                                    Your fitting is <br /> guaranteed
                                </h1>
                                <h2>
                                    <span className="show_mobile">
                                        If you go through our process and we can't produce an option that outperforms your current set, your fitting is free.
                                    </span>
                                </h2>
                                <div className="arrow_animation show_mobile bounce pt-3">
                                    <i className="bi bi-arrow-down-short"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hide_mobile_f btn-group-list mt-2" role="group" aria-label="Basic example">
                        <button className="btn btn-primary btn_default2" onClick={showfunction}>
                            Book Your Fitting
                        </button>
                        {/* <button className="btn btn-primary btn_default2" onClick={handleShowfitter}>
                            Become a Fitter
                        </button> */}
                        {
                            isLoggedIn ? (<button className="btn btn-primary btn_default2" onClick={handleShowFitterlogin}>
                                Go to dashboard
                            </button>) : (
                                <button className="btn btn-primary btn_default2" onClick={handleShowfitter}>
                                    Become a Fitter
                                </button>
                            )
                        }
                    </div>
                </div>
            </section>
            <OurProcess />
            <section id="iron_head" className="iron_head bg_dark page-section Build_your_iron" style={{ background: "#1d2025" }}>
                <div className="container-xl">
                    {/* <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Iron Head</h2>
                    </div> */}
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="iron_content">
                                <h1 className="">
                                    Book your <br /> club fitting
                                </h1>
                                <h2 className="">
                                    <span className="hide_mobile">
                                        Book an appointment with us below to get <br />
                                        any and every part of your bag dialed. If it <br />
                                        doesn’t work we don’t sell it.
                                    </span>
                                    <span className="show_mobile">
                                        Book an appointment with us below to get <br /> any and every part of your bag dialed.
                                    </span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5 col-md-6 iron_step_container">
                            <div className="iron_step">
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content">
                                        <h3>Choose your fitting</h3>
                                        <p>In person or remote, we have options.</p>
                                    </div>
                                </div>
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content">
                                        <h3>Book an appointment</h3>
                                        <p>Assume nothing and test all variables.</p>
                                    </div>
                                </div>
                                <div className="iron_step_item">
                                    <div className="iron_step_icon2">
                                        <BsCheck2 />
                                    </div>
                                    <div className="iron_step_content last_iron">
                                        <h3>Get fit, not sold.</h3>
                                        <p>We only recommend clubs that work.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <RemoateFitting setuserlogin={(loginusercallback) => setloginusercallback(loginusercallback)} showpopup={showpopup} setpupfalse={(poparg) => setShowPopup(poparg)} />
            <FittingRates />
            {/* <FindFitting /> */}
            <ClubFitting />
            <ContactUs />
            <Footer />
            <style>
                {`
                    @media only screen and (max-width: 991px){
                        .btn-group-list.mt-2 .btn.btn_default2 {
                            max-width: 200px !important;
                            margin: 0;
                            padding: 0 10px;
                            height:60px;
                        }
                        .btn-group-list.mt-2{
                            margin-top: 1rem !important;
                        }
                    }
                    @media only screen and (min-width: 768px) and (max-width: 991px) {
                        .hero_content {
                            padding-top: 125px;
                        }
                    }
                    @media only screen and (min-width: 481px) and (max-width: 767px){
                        .btn-group-list.mt-2 .btn.btn_default2{
                            font-size: 18px;
                        }
                    }

                    .btn-group-list.mt-2 .btn_default2:nth-child(1) {
                        background: #98ea24 !important;
                        font-weight: 700 !important;
                        color: #000000 !important;
                    }

                    .btn-group-list.mt-2 .btn_default2:nth-child(2) {
                        background: #ffffff !important;
                        font-weight: 700 !important;
                        color: #000000 !important;
                    }
                `}
            </style>
        </>
    );
}

export default Clubfitting;